import * as React from 'react'

import { SwatchElement } from './SwatchElement'
import { SwatchContainer } from './styles'

export enum SwatchShape {
  Circle = 'circle',
  Square = 'square',
}

export enum SwatchSize {
  Small = 'small',
  Large = 'large',
}

export interface ColourChoice {
  key: string
  colour: string
  title: string
  disabled?: boolean
  href?: string
}

export interface SwatchProps {
  shape: SwatchShape
  size?: SwatchSize
  colours: ColourChoice[]
  selectedColour?: string
  onColourChange?: (value: string) => void
  i18nText: {
    unavailableText: string
    closeButtonText: string
  }
  displaySwatch?: boolean
  className?: string
}

export const Swatch = (props: SwatchProps) => {
  const [selectedColour, setSelectedColour] = React.useState<
    string | undefined
  >(props.selectedColour)

  React.useEffect(() => {
    setSelectedColour(props.selectedColour)
  }, [props.selectedColour])
  return (
    <SwatchContainer
      className={props.className}
      displaySwatch={props.displaySwatch ?? false}
    >
      {props.colours.map((choice: ColourChoice) => {
        return (
          <SwatchElement
            key={choice.key}
            choice={choice}
            onClick={
              props.onColourChange
                ? () => {
                    setSelectedColour(choice.title)
                    props.onColourChange?.(choice.title)
                  }
                : undefined
            }
            selected={selectedColour === choice.title}
            shape={props.shape}
            size={props.size}
            i18nText={props.i18nText}
          />
        )
      })}
    </SwatchContainer>
  )
}
